import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../../../utils/apiPath"
import { agent } from "../../../../utils/agent";

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ data, forgotString }, { rejectWithValue }) => {
    try {
      const payload = {
        ...data,
        forgot_password_validate_string: forgotString,
      };

      const response = await agent.post(API.RESETPASSWORD, payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Reset failed");
    }
  }
);

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: {
    loading: false,
    successMessage: null,
    errorMessage: null,
  },
  reducers: {
    clearMessages(state) {
      state.successMessage = null;
      state.errorMessage = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload;
      });
  }
});

export const { clearMessages } = resetPasswordSlice.actions;

export default resetPasswordSlice.reducer;
